import React from 'react';
import FieldBase from './FieldBase';
import { IFieldBaseProperties, IFieldValueProperties } from './interfaces';
import FieldTypes from './enums/FieldTypes';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface IRichTextEditorFieldProperties extends IFieldBaseProperties, IFieldValueProperties { }

export class RichTextEditorField extends React.PureComponent<IRichTextEditorFieldProperties> {
  constructor(props: IRichTextEditorFieldProperties) {
    super(props);
    
    this.onChange = this.onChange.bind(this);
  }

  onChange(content: string) {
    if (this.props.onChange !== undefined)
    {
      this.props.onChange({
        id: this.props.id,
        name: this.props.id,
        value: content
      });
    }
  }

  render() {
    return <FieldBase key={this.props.id + "_field"} {...this.props} type={FieldTypes.TEXT}>
      <ReactQuill theme="snow" value={this.props.value || ''} onChange={this.onChange} />
    </FieldBase>;
  }
}

export default RichTextEditorField;